import React, { useState } from 'react';
import { Row, Col } from '@themesberg/react-bootstrap';
import { showOk } from '../components/Alerts';
import { Button, Modal, Form } from '@themesberg/react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import clientApi from '../services/client-service';

const ClientArchiveReason = (props) => {
  const { 
    clientId,
    cancelEvent,
    refreshList
  } = props;

  const { Header, Dialog, Title, Body, Footer } = Modal;
  const [loading, setLoading] = useState(false);
  const { setClientStatus } = clientApi;

  const archiveClientSchema = Yup.object().shape({
    reason: Yup.string().required('Reason is required'),
  });

  const formOptions = {
    resolver: yupResolver(archiveClientSchema),
    mode: 'all',
  };

  const { register, handleSubmit, getValues, formState, reset } = useForm(formOptions);

  const { errors } = formState;

  const handleArchiveClient = () => {
    setLoading(true);

    let clientData = new FormData();

    const reason = getValues('reason');

    clientData.append('clientId', clientId);
    clientData.append('status', false);
    clientData.append('reason', reason);

    setClientStatus(clientData).then(() => {
        showOk('Client archived!');
        reset();
        cancelEvent();
        refreshList();
    });
  }

  return (
    <Modal as={Dialog} backdropClassName="" centered show={true}>
      <Form onSubmit={handleSubmit(handleArchiveClient)}>
        <Header>
          <Title className="h6">Provide reason why your archive the client</Title>
          <Button variant="close" aria-label="Close" onClick={() => cancelEvent()} />
        </Header>
        <Body>
            <Row className='align-items-start'>
                <Col sm={12} className="mb-3">
                    <Form.Group id="reason">
                        <Form.Label className="light-font">Reason</Form.Label>
                        <Form.Control as="textarea" placeholder='Please add reason' {...register('reason')} rows="3" />
                        {errors.reason?.message && <small className="invalid-fields">{errors.reason.message}</small>}
                    </Form.Group>
                </Col>
            </Row>
        </Body>
        <Footer>
          <Button type="submit" disabled={loading} variant="secondary">
            Submit
          </Button>
          <Button variant="primary" className="ms-auto" onClick={() => cancelEvent()}>
            Cancel
          </Button>
        </Footer>
      </Form>
    </Modal>
  );
};

export default ClientArchiveReason;
